var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M0 27C0 12.09 12.088 0 27 0h5v19a8 8 0 0 1-8 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m20.455 11.853-2.222-4.314-2.385 4.25-4.8.8 3.293 3.56-.745 4.81 4.42-2.048 4.34 2.17-.561-4.826 3.427-3.469z",
    clipRule: "evenodd"
  })));
};
export default SvgStar;